import {
  useWSModalCustom,
  useWSSnackbar,
  WSAlert,
  WSList,
  WSModal,
  WSModalCustomProps,
  WSText
} from "@wingspanhq/fe-component-library";
import { WorkLog } from "@wingspanhq/wingspan-api-sdk";
import { queriesWorkLogs } from "@query";

type Props = {
  workLog: WorkLog;
} & WSModalCustomProps<{
  success?: boolean;
}>;

export const ModalSubmitForReview: React.FC<Props> = ({
  workLog,
  ...modalProps
}) => {
  const { openSnackbar } = useWSSnackbar();
  const [submitForReview, submitMeta] =
    queriesWorkLogs.submitWorkLog.useMutation();

  return (
    <WSModal
      title="Submit for review"
      actions={{
        alignment: "fill",
        buttons: [
          {
            kind: "Secondary",
            label: "No, keep editing",
            onClick: () => {
              modalProps.onClose({ success: false });
            }
          },
          {
            kind: "Primary",
            label: "Yes, submit for review",
            onClick: () => {
              // TODO(v3): submitWorkLog takes no comment — v1's payeeOwnedData.comment:null clear on submit is dropped.
              submitForReview(
                { workLogId: workLog.id! },
                {
                  onSuccess: () => {
                    modalProps.onClose({ success: true });
                    openSnackbar({
                      icon: { name: "check" },
                      message: "Work log submitted for review"
                    });
                  },
                  onError: () => {
                    openSnackbar({
                      type: "warning",
                      message:
                        "Failed to submit work log for review. Please try again."
                    });
                  }
                }
              );
            },
            loading: submitMeta.isLoading
          }
        ]
      }}
      {...modalProps}
    >
      <WSList gap="XL">
        <WSText.ParagraphSm color="gray500">
          Are you sure you want to submit the work log for review?
        </WSText.ParagraphSm>

        <WSAlert
          theme="info"
          title="About work log submissions"
          icon="info-circle"
        >
          Once a work log is submitted, it cannot be edited while in review.
          Please ensure the work summary is accurate before submitting for
          client review. To continue editing the work log, click &quot;No, keep
          editing&quot;.
        </WSAlert>
      </WSList>
    </WSModal>
  );
};

export const useModalSubmitForReview = () =>
  useWSModalCustom(ModalSubmitForReview);
